import { render, staticRenderFns } from "./EmailFrequencyDescriptionCard.vue?vue&type=template&id=e3a9f51a&scoped=true"
import script from "./EmailFrequencyDescriptionCard.vue?vue&type=script&lang=js"
export * from "./EmailFrequencyDescriptionCard.vue?vue&type=script&lang=js"
import style0 from "./EmailFrequencyDescriptionCard.vue?vue&type=style&index=0&id=e3a9f51a&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a9f51a",
  null
  
)

export default component.exports